import Icon from '../components/Icon.vue'

Icon.register({
  hippo: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M581.1 96.2C553.5 96.1 528.6 113.8 504.5 122.8 490 88.3 455.8 64 416 64 404.7 64 394.1 66.3 384 69.9V56C384 42.7 373.3 32 360 32H344C330.8 32 320 42.7 320 56V105C286 79.6 241.2 64 192 64 86 64 0 135.6 0 224V464C0 472.8 7.2 480 16 480H80C88.8 480 96 472.8 96 464V393.2C128.3 407.6 166.7 416 208 416S287.6 407.6 320 393.2V464C320 472.8 327.2 480 336 480H400C408.8 480 416 472.8 416 464V288H544V320C544 328.8 551.2 336 560 336H592C600.8 336 608 328.8 608 320V288C625.7 288 640 273.7 640 256V164C640 129.9 615.2 96.4 581.1 96.2zM448 176C439.2 176 432 168.8 432 160S439.2 144 448 144 464 151.2 464 160 456.8 176 448 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hippo.js
// module id = TFw1
// module chunks = 144